import React from "react";

const SequencerSeekbar = ({ height }) => {
  return (
    <svg
      width="16"
      height={height}
      viewBox={`0 0 16 ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 22C0 20.8954 0.895431 20 2 20H14C15.1046 20 16 20.8954 16 22V30.0392C16 30.8203 15.5453 31.5299 14.8357 31.8562L8 35L1.16433 31.8562C0.454704 31.5299 0 30.8203 0 30.0392V22Z"
        fill="#6C65D9"
      />
      <path d={`M8 35L8.00001 ${height}`} stroke="#606479" strokeWidth="3" />
    </svg>
  );
};

export default SequencerSeekbar;
